import type { AddressSuggestion } from '@@partner:types:app'

import React, { useCallback, useState } from 'react'

import { InputGroup, Form, Button } from 'rsuite'
import AddressAutosuggest from './AddressAutoSuggest'
import CustomerAddressValidationMessage from '../common/CustomerAddressValidationMessage'

export interface CustomerAddressProps {
  onAddressChosen: (suggestion: AddressSuggestion) => void
  onChange?: (addressValue: string) => void
  onSearchClick?: () => void
  searchBtn?: string | JSX.Element
  searchBtnDisabled?: boolean
  loading?: boolean
  noSearchBtn?: boolean
  name?: string
  placeholder?: string
}

const CustomerAddress: React.FC<
  CustomerAddressProps & React.HTMLAttributes<HTMLDivElement>
> = ({
  className,
  onChange,
  onAddressChosen,
  onSearchClick,
  searchBtn = 'Найти',
  searchBtnDisabled = false,
  loading = false,
  noSearchBtn = false,
  name = 'address',
  placeholder = 'Укажите адрес клиента'
}) => {
  const [ lastChosenSuggestion, setLastChosenSuggestion ] =
    useState<AddressSuggestion | null>(null)

  const handleSuggestionSelected = useCallback(
    (_event: any, { suggestion }: { suggestion: AddressSuggestion }) => {
      setLastChosenSuggestion(suggestion)
      onAddressChosen?.(suggestion)
    },
    [ onAddressChosen ]
  )

  return (
    <div className={className}>
      {lastChosenSuggestion !== null && (
        <CustomerAddressValidationMessage suggestion={lastChosenSuggestion} />
      )}

      <InputGroup>
        <Form.Control
          accepter={AddressAutosuggest}
          placeholder={placeholder}
          onChange={(address: string) => onChange?.(address)}
          name={name}
          onSuggestionSelected={handleSuggestionSelected}
          // className="CustomerAddress__Body__Control rs-input"
        />
        {!noSearchBtn && (
          <Button
            disabled={searchBtnDisabled}
            appearance="primary"
            className="CustomerAddress__Btndiv__Btn"
            onClick={onSearchClick}
            loading={loading}
          >
            {searchBtn}
          </Button>
        )}
      </InputGroup>
    </div>
  )
}
export default CustomerAddress
